/** Twilio's limit and the backend's (`POST /lead/{id}/sms` accepts 1–1,600 chars). */
export const SMS_MAX_CHARS = 1600;

// GSM 03.38: the basic set costs one septet per char, the extension set two
// (escape + char). Anything outside both forces UCS-2 for the whole message.
const GSM_BASIC = new Set(
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
);
const GSM_EXTENDED = new Set("^{}\\[~]|€\f");

/**
 * Segments the carrier bills for `text`: GSM-7 fits 160 chars in one part and
 * 153 per part once split; UCS-2 (any non-GSM char, e.g. an emoji) 70 / 67,
 * counted in UTF-16 code units like the provider does.
 */
export function smsSegments(text: string): number {
  if (!text) return 0;
  let septets = 0;
  for (const ch of text) {
    if (GSM_BASIC.has(ch)) septets += 1;
    else if (GSM_EXTENDED.has(ch)) septets += 2;
    else return text.length <= 70 ? 1 : Math.ceil(text.length / 67);
  }
  return septets <= 160 ? 1 : Math.ceil(septets / 153);
}

/**
 * The characters `text` cannot send as GSM-7 (emoji, smart quotes, most
 * non-Latin scripts), deduplicated in order of appearance. The composer blocks
 * them: a text with any of these goes out as UCS-2, which carriers have been
 * refusing on our numbers (Twilio 30008).
 */
export function nonGsmChars(text: string): string[] {
  const found = new Set<string>();
  for (const ch of text) {
    if (!GSM_BASIC.has(ch) && !GSM_EXTENDED.has(ch)) found.add(ch);
  }
  return [...found];
}
